import { render, staticRenderFns } from "./RadioboxMarked.vue?vue&type=template&id=b08ba958&functional=true&"
import script from "./RadioboxMarked.vue?vue&type=script&lang=js&"
export * from "./RadioboxMarked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports